import request from '@/utils/request';

function getBaseRequest(basePath) {
  return function baseRequest(path, payload, method, config = {}) {
    return request({
      url: `/${basePath}/${path}`,
      method,
      data: method === 'get' || method === 'delete' ? null : payload,
      params: method === 'get' || method === 'delete' ? payload : null,
      ...config,
    }).then(res => res.data);
  };
}

const baseRequest = getBaseRequest('deploy');

const jenkinsRequest = getBaseRequest('jenkins');

const algoArRequest = getBaseRequest('algo-ar');

/**
 * 获取部署表格页面
 * @return {*}
 */
export function getDeployList() {
  return baseRequest('page', undefined, 'get');
}

/**
 * 修改部署
 * @param payload
 * @return {Promise<*>}
 */
export function modifyDeploy(payload) {
  return baseRequest('modify', payload, 'post');
}

export function refreshParam(id) {
  return baseRequest(`param/${id}`, undefined, 'get');
}

export function refreshConfig(id) {
  return baseRequest(`config/${id}`, undefined, 'get');
}

export function saveParam(id, payload) {
  return baseRequest(`param/${id}`, payload, 'post');
}

export function saveConfig(id, group, configData) {
  return baseRequest(`config/${id}?group=${group}`, configData, 'post');
}

/**
 * 部署服务
 * @param payload
 * @return {Promise<unknown>}
 */
export function deployService(payload) {
  return jenkinsRequest('robot-vr-navigation-service/buildWithParameters', payload, 'get');
}

export function deployNavigationData(payload) {
  return jenkinsRequest('robot-vr-navigation-data/buildWithParameters', payload, 'get');
}

export function jenkinsHealth() {
  return jenkinsRequest('health', undefined, 'get', { timeout: 3000 });
}

export function getDeployVersion(payload) {
  return algoArRequest('admin/ar/location_deployment/version', payload, 'get', {
    headers: {
      token: payload.token,
    },
  });
}

export function locationDeployment(payload) {
  return algoArRequest('admin/ar/location_deployment', payload, 'get', {
    headers: {
      token: payload.token,
    },
  });
}

/**
 * 发布车位信息，C端会查询
 * @param {*} payload
 * @returns
 */
export function deployParkingSpace(payload) {
  return request({
    url: '/locate/mini/parking/publish',
    method: 'post',
    data: payload,
  });
}
